import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>
  Registry Operator Terms and Conditions Applicable to all .EU Registrations
    </h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>1. Definitions</strong>
    </p>
    <p>
  The following definitions apply to .eu Terms and Conditions of this Schedule
  only.
    </p>
    <blockquote>
  <p>
    1.1. "ADR Procedure" has the meaning ascribed to it in the .eu Dispute
    Resolution Rules which can be found at the EURid webpage at{' '}
    <a href="http://www.eurid.eu" target="_blank">
      www.eurid.eu
    </a>
    .
  </p>
  <p>
    1.2. "Domain Name" means a domain name registered directly under the .eu Top
    Level Domain or for which a request or application for registration has been
    filed with the Registry.{' '}
  </p>
  <p>
    1.3. ".eu Regulation" means Regulation (EC) No 733/2002 of the European
    Parliament and of the Council of 22 April 2002 on the implementation of the
    .eu Top Level Domain, OJ L, 113, 30 April 2002, pp. 1-5;
  </p>
  <p>
    1.4. "Registry" means EURid vzw/asbl, a not-for-profit organization duly
    incorporated and validly existing under the laws of Belgium, with registered
    office at Park Station, Woluwelaan 150, 1831 Diegem (Belgium).
  </p>
  <p>
    1.5. "Registration Policy" means the document available on the Website of
    the Registry.
  </p>
  <p>
    1.6. "Rules" means the .eu Domain Name Registration Terms and Conditions,
    the Registration Policy, the .eu Dispute Resolution Rules, the Sunrise Rules
    (when applicable), the Registration Guidelines and the Regulations which can
    be located at the EURid webpage at{' '}
    <a href="http://www.eurid.eu" target="_blank">
      www.eurid.eu
    </a>
    . It is recommended that you read these documents.
  </p>
    </blockquote>
    <p>
  <strong>2. Introduction</strong>
    </p>
    <blockquote>
  <p>
    2.1. Before registering a .eu Domain Name, you should take the time to
    review our General Terms and Conditions and all the Rules and policy
    documents that the Registry has published on their webpage. The webpage of
    the Registry is available at{' '}
    <a href="http://www.eurid.eu" target="_blank">
      www.eurid.eu
    </a>
    . You acknowledge that you have read and agree to our Terms and Conditions
    and the Registry's Rules.
  </p>
    </blockquote>
    <p>
  <strong>3. Eligibility Requirements</strong>{' '}
    </p>
    <p>
  In order to register a .eu Domain Name you hereby verify that you meet the
  General Eligibility Criteria pursuant to Art 4 (2)(b) of the .eu Regulation,
  whereby you must be:
    </p>
    <blockquote>
  <p>
    3.1. an undertaking having its registered office, central administration or
    principal place of business within the Community;
  </p>
  <p>
    3.2. an organisation established within the Community without prejudice to
    the application of national law; or{' '}
  </p>
  <p>3.3. a natural person resident within the Community.</p>
    </blockquote>
    <p>
  Community countries and territories can be located under the .eu Domain Name
  Registration Policy at{' '}
  <a href="http://www.eurid.eu" target="_blank">
    www.eurid.eu
  </a>
  .{' '}
    </p>
    <p>
  <strong>4. Obligations of the Registrant</strong>{' '}
    </p>
    <p>Throughout the Term, the Registrant has the following obligations:</p>
    <blockquote>
  <p>
    4.1. to keep your contact information, as referred to in the Registration
    Policy, accurate, complete and up to date, both (i) with the Registrar with
    whom the Registrant has entered into an Agreement and (ii) with the Registry
    (via the Registrar), as described in the Registration Policy. Moreover, the
    Registrant represents and warrants that any email address communicated to
    the Registry shall be a functioning email address;
  </p>
  <p>
    4.2. to use the Domain Name in such way that it does not violate any third
    party rights, applicable laws or regulations, including discrimination on
    the basis of race, language, sex, religion or political view;
  </p>
  <p>
    4.3. not to use the Domain Name (i) in bad faith or (ii) for any unlawful
    purpose.
  </p>
    </blockquote>
    <p>
  <strong>5. Representations and Warranties</strong>{' '}
    </p>
    <p>You represent and warrant that:</p>
    <blockquote>
  <p>
    5.1. you meet one of the General Eligibility Criteria, and you shall inform
    us when you cease to meet such conditions;
  </p>
  <p>
    5.2. all information provided to the Registry during the Domain Name
    registration process is true, complete and accurate;
  </p>
  <p>
    5.3. the request for Domain Name registration is made in good faith, for a
    lawful purpose and does not infringe the rights of any third party;
  </p>
  <p>
    5.4. the Domain Name is not contrary to public policy or morality (e.g. is
    not obscene or offensive) and is not unlawful; and
  </p>
  <p>
    5.5. you shall, throughout the Term, abide by these Terms and Conditions as
    issued by EURid and any and all applicable Rules.
  </p>
    </blockquote>
    <p>
  <strong>6. Term and Renewal of the Domain Name</strong>
    </p>
    <blockquote>
  <p>
    6.1. The Term of any Domain Name registration shall commence on the date of
    registration of the Domain Name, and shall end the following calendar year,
    within which the Domain Name was registered.
  </p>
  <p>
    Unless otherwise provided for herein, the Term shall be tacitly renewed for
    an additional period that shall end the following calendar year, within
    which the Domain Name was renewed, transferred or reactivated.
  </p>
  <p>
    6.2. Any renewal of your services with us is subject to our then current
    terms and conditions and payment of all applicable service fees at the time
    of renewal and, in the case of domain name re-registration, the domain name
    registry's acceptance of your domain name registration.
  </p>
  <p>
    6.3. You may cancel your Domain Name before the Renewal Date if you have
    provided us with a cancellation request.{' '}
  </p>
    </blockquote>
    <p>
  <strong>7. Transfer of Domain Name</strong>
    </p>
    <blockquote>
  <p>
    7.1. The Registrant shall be entitled to transfer a Domain Name where the
    following conditions are cumulatively met:
  </p>
  <blockquote>
    <p>
      7.1.1. the transferee has confirmed that it satisfies the General
      Eligibility Criteria; and
    </p>
    <p>
      7.1.2. the Registry has received all applicable fees for such transfer via
      the Registrar appointed by the transferee; and
    </p>
    <p>
      7.1.3. the procedure described in Section 13 of the Registration Policy
      has been successfully completed.
    </p>
  </blockquote>
  <p>7.2. Suspended or blocked Domain Name cannot be transferred unless</p>
  <blockquote>
    <p>
      7.2.1. A decision has been renderered by (a) a panel in an ADR Procedure,
      or (b) by a court of a Member State; or
    </p>
    <p>
      7.2.2. upon receipt by the Registry of any fees applicable in this
      respect, in case the Domain Name has been suspended in accordance with
      Section 9 of the .eu Domain Name Registration Terms and Conditions.
    </p>
  </blockquote>
    </blockquote>
    <p>
  <strong>8. Change of Registrar</strong>
    </p>
    <p>
  In the event that the agreement (a) between the Registry and the Registrar or
  (b) between the Registrar and the Registrant is terminated, the Registrant
  shall follow the relevant procedure set out in Section 10 of the Registration
  Policy in order to maintain its Domain Name registration. You agree that you
  may not transfer your domain name registration to another domain name
  registrar during the first sixty (60) days from the effective date of your
  initial domain name registration with us.
    </p>
    <p>
  <strong>9. Suspended, Blocked and Revoked Domain Names</strong>
    </p>
    <p>
  The Registry may suspend, block or revoke a Domain Name pursuant to section 9
  of the .eu Domain Name Registration Terms and Conditions. It is recommended
  that you read these provisions.
    </p>
    <p><strong>10.	Rights Granted</strong></p>
    <blockquote>
	<p>10.1.	The Registrant acknowledges that upon registration of a Domain Name, the Registrant obtains a limited, transferable, renewable, exclusive right to use the Domain Name for the Term, unless otherwise provided for in the Rules. No other rights can be claimed by the Registrant except for those included herein.
	</p><p>10.2.	The Registrant shall not be entitled to exercise any right of withdrawal following receipt by the Registry of an application or request for registration of a Domain Name.
      </p></blockquote>
    <p><strong>11.	Communication Between the Registry and the Registrant</strong></p>
    <blockquote>
	<p>11.1.	Any official communication between the Registry and the Registrant shall be effected by email:</p>
	<blockquote>
		<p>11.1.1.	if to the Registry: <a href="mailto:info@eurid.eu">info@eurid.eu</a>;
		</p><p>11.1.2.	if to the Registrant: the contact email address communicated to the Registry via the Registrar and made available in the WHOIS Database.
	</p></blockquote>
	<p>11.2.	Any communication between the Registry and the Registrant shall be in one of the official languages of the European Union.
      </p></blockquote>
    <p><strong>12.	Privacy and Data Protection</strong></p>
    <blockquote>
      <p>12.1.	Processing of personal data:</p>
	<blockquote>
	<p>12.1.1.	By registering a Domain Name and accepting the Terms and Conditions, the Registrant authorises the Registry to process personal and other data required to operate the ".eu" Domain Name system. The Registry must only use the data for operating the system (which will include attribution of the Domain Name, transfer of a Domain Name to a new Registrant, transfer of one Domain Name or a portfolio of Domain Names to a new Registrar) and can after the unambiguous consent of the Registrant transfer the data to third parties but only:</p>
		<blockquote>
			<p>12.1.1.1.	if ordered to do so by a public authority, carrying out its legitimate tasks,</p>
			<p>12.1.1.2.	upon demand of the ADR Providers mentioned in section 16 of this document ;or</p>
			<p>12.1.1.3.	as provided in Section 12.3 of the .eu Domain Name Registration Terms and Conditions.</p>
		</blockquote>
	<p>12.1.2.	You have the right to access your personal data and to amend any errors that may exist.</p>
	</blockquote>
      <p>12.2.	Information collected by Registry:</p>
	<blockquote>
	<p>12.2.1.	The Registry will collect the following personal data for its internal use:</p>
		<blockquote>
		<p>12.2.1.1.	full name of the Registrant;</p>
		<p>12.2.1.2.	technical contact name;</p>
		<p>12.2.1.3.	postal address;</p>
		<p>12.2.1.4.	email address;</p>
		<p>12.2.1.5.	telephone number;</p>
		<p>12.2.1.6.	fax number (optional);</p>
		<p>12.2.1.7.	language for ADR proceedings, as referred to in Paragraph 3(a) of the .eu Dispute Resolution Rules.</p>
		</blockquote>
	<p>12.2.2.	Such information may be published in its WHOIS.  Please review section 3.1 of the .eu Domain Name Registration Terms and Conditions can be located at <a href="http://www.eurid.eu" target="_blank">www.eurid.eu</a>.</p>
	</blockquote>
	<p>12.3.	Disclosure of personal data:</p>
		<blockquote>
		<p>12.3.1.	The Registry may disclose personal data of the Registrant not published in the WHOIS to third parties having legitimate reasons for disclosure.</p>
		<p>12.3.2.	Please take the time to review the .eu Domain Name Registration Terms and Conditions and WHOIS Policy of when disclosure will be granted.</p>
		</blockquote>
    </blockquote>
    <p><strong>13.	Limitation of Liability</strong></p>
    <blockquote>
      <p>13.1.	The Registry shall not be liable for any loss, including direct or indirect loss, consequential loss and loss of profits, whether contractual, based on tort (including negligence) or otherwise arising, resulting from or related to registration or use of a Domain Name or to use of its software or Website of the Registry, even if it has been advised of the possibility of such loss, including but not limited to:</p>
	<blockquote>
	<p>13.1.1.	registration or renewal of (or the failure to register or renew) a Domain Name in favour of a Registrant or a third party due to an error concerning their identity;</p>
	<p>13.1.2.	termination of the Registry's authority to register domain names n the .eu Top Level Domain;</p>
	<p>13.1.3.	rights that third parties might claim to a Domain Name, </p>
	<p>13.1.4.	technical problems or faults;</p>
	<p>13.1.5.	acts or omissions of a Registrar regarding the application or equest for registration, registration or renewal of a Domain Name that may result in non-registration or cancellation of such Domain Name; 
	except in cases where the Registry's wilful misconduct is proved. </p>
	</blockquote>
      <p>13.2.	In any case, the Registry's liability for damages shall be limited to the amount of the registration fee that applies at the time the dispute is raised with the Registry. The Registrant agrees that no greater or other damages may be claimed from the Registry. </p>
      <p>13.3.	The Registrant shall be liable for any costs, expenses or damages incurred by the Registry for any breach of these Terms and Conditions by the Registrant. Furthermore, the Registrant shall hold the Registry harmless from claims filed or disputes initiated by third parties to this Agreement, and shall compensate the Registry for any costs or expenses incurred or damages it may suffer through third parties taking action against it on the grounds that the application for, the registration or the use of the Domain Name by the Registrant infringe the rights of said third parties.</p>
      <p>13.4.	For the purposes of this Section, the term "Registry" shall also refer to its members, subcontractors and their respective directors and employees.</p>
    </blockquote>
    <p><strong>14.	Applicable Law and Jurisdiction</strong></p>
    <blockquote>
	<p>14.1.	The Terms and Conditions and any dealings between the Registry and the Registrant hereunder are subject to Belgian law. In the event of any dispute, disagreement or claim between the Registry and the Registrant, the courts in Brussels (Belgium) shall have exclusive jurisdiction, except for the cases referred to in Section 16 of the .eu Domain Name Registration Terms and Conditions.</p>
	<p>14.2.	Any terms and conditions and any dealings between the Registrar and Registrant are subject to the Laws of the Province of Ontario, Canada.  In the event of any dispute, disagreement or claim between the Registrar and the Registrant, the courts in Ottawa, Ontario, Canada shall have exclusive jurisdiction.</p>
    </blockquote>
    <p><strong>15.	Alternative Dispute Resolution ("ADR")</strong></p>
    <blockquote>
      <p>15.1.	The Registrant accepts that ADR Procedures must be conducted before one of the providers listed at the Website of the Registry (<a href="http://www.eurid.eu" target="_blank">www.eurid.eu</a>). </p>
      <p>15.2.	The Registrant must participate in ADR Procedures if a third party (a “Complainant”), in compliance with the .eu Dispute Resolution Rules, asserts to an ADR Provider and initiates a complaint against the Registrant on the basis of speculative or abusive registration, as referred to in Articles 21 and 22(1)(a) of the Public Policy Rules.</p>
      <p>Furthermore, the Registrant or a third party shall be entitled to initiate an ADR Procedure in accordance with the procedures laid down in the Rules if it is of the view that a decision taken by the Registry conflicts with the Regulations.</p>
      <p>15.3.	Unless otherwise agreed by the parties to an ADR Procedure or otherwise specified in the agreement between the Registrant and its Registrar, the language of the ADR Procedure shall be in the English language. Any ADR Procedure initiated against the Registry shall be conducted in the English language.</p>
      <p>15.4.	All disputes covered by this section will be governed by the .eu Dispute Resolution Rules applicable upon filing of the complaint and the selected ADR Provider's rules of procedure, as published on the Website of the Registry (<a href="http://www.eurid.eu" target="_blank">www.eurid.eu</a>).</p>
      <p>15.5.	The remedies available to a Complainant under any proceedings before an arbitrator (or panel of arbitrators) appointed by an ADR Provider are strictly limited to: </p>
	<blockquote>
	<p>15.5.1.	annulment of the challenged Registry decision, in case the ADR Procedure is initiated on the basis of Article 22(1)(b) of the Public Policy Rules; and</p>
	<p>15.5.2.	revocation or transfer of the Domain Name in case the ADR procedure is initiated on the basis of Article 21.1(a) of the Public Policy Rules.</p>
	</blockquote>
    </blockquote>
    <p><strong>16.	Amendments</strong></p>
    <blockquote>
      <p>16.1.	The Terms and Conditions in this Schedule are subject to change by the Registry or the Registrar.  You should review section 14 of the .eu Domain Name Registration Terms and Conditions for provisions not listed in this Schedule.</p>
      <p>16.2.	If the Registry decides to change these Terms and Conditions and/or the Registration policy, it will make the new terms available to the public by posting them on the Website of the Registry at least thirty (30) days before the new terms take effect (and upon their taking effect on the announced date, said new terms shall become the Terms and Conditions and/or the Registration Policy). Each Domain Name registration will be handled according to the Rules in effect on the date the application or request for a Domain Name registration is complete.  You are recommended to periodically check the Registry's webpage for any new amendments.</p>
    </blockquote>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      